export const SET_THEME = 'theme/set_theme'

const initialState = {
  loaded: false,
  colors: {},
  beePlugin: {},
  tracker: {},
  slack: {},
  linkApp: {},
  linkFooter: [],
  optionsAvailable: [],
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME:
      // Define the title page from theme
      document.title = action.payload.title

      const link = document.querySelector("link[rel*='shortcut icon']")
      link.href = action.payload.images.favicon

      return {
        ...state,
        ...action.payload,
        loaded: true,
      }
    default:
      return state
  }
}

export default reducer
